import { createSlice } from "@reduxjs/toolkit";

import { IFaqStore } from "../types";

const initialState: IFaqStore = {
  faqs: [],
};

export const faqSlice = createSlice({
  name: "faq",
  initialState,
  reducers: {
    setFaqs: (state, { payload }) => {
      state.faqs = payload;
    },
  },
});

export const { setFaqs } = faqSlice.actions;
